import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SUBSCRIPTION_TIERS, type SubscriptionTier } from '../data/subscriptions';

export const useSubscriptionTiers = (): SubscriptionTier[] => {
  const { t } = useTranslation();

  return useMemo(
    () =>
      SUBSCRIPTION_TIERS.map((tier) => ({
        ...tier,
        name: t(`subscription.tiers.${tier.id}.name`, { defaultValue: tier.name }),
        priceLabel: t(`subscription.tiers.${tier.id}.price`, { defaultValue: tier.priceLabel }),
        description: t(`subscription.tiers.${tier.id}.description`, { defaultValue: tier.description }),
        features: t(`subscription.tiers.${tier.id}.features`, {
          returnObjects: true,
          defaultValue: tier.features,
        }) as string[],
      })),
    [t],
  );
};
